// extracted by mini-css-extract-plugin
module.exports = {"innerDoc":"InnerDoc_innerDoc__2uMt7"};